import React, { useState } from 'react';
import { Form, Button, Alert, Card } from 'react-bootstrap';
import { User, ArrowLeft } from 'lucide-react';
import { getFuncionarioByCode } from '../../services/funcionarioService';
import { Funcionario } from '../../types';
import { toast } from 'react-toastify';
import './FuncionarioLogin.css';

interface FuncionarioLoginProps {
  onLoginSuccess: (funcionario: Funcionario) => void;
  onBackToMain: () => void;
}

const FuncionarioLogin: React.FC<FuncionarioLoginProps> = ({ 
  onLoginSuccess, 
  onBackToMain 
}) => {
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!codigo.trim()) {
      setError('Código de acesso é obrigatório');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Buscar funcionário por código em todos os usuários
      const result = await getFuncionarioByCode(codigo.trim());
      
      if (result.success && result.data) {
        toast.success(`Bem-vindo(a), ${result.data.nome}!`);
        onLoginSuccess(result.data);
      } else {
        setError('Código de acesso inválido ou funcionário inativo');
        toast.error('Código de acesso inválido ou funcionário inativo');
      }
    } catch (err) {
      console.error('❌ Erro ao fazer login:', err);
      setError('Erro ao fazer login. Tente novamente.');
      toast.error('Erro ao fazer login. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setCodigo('');
    setError('');
    onBackToMain();
  };

  return (
    <div className="funcionario-login-container">
      <div className="funcionario-login-background">
        <div className="funcionario-login-content">
          <Card className="funcionario-login-card">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <div className="funcionario-login-icon">
                  <User size={48} />
                </div>
                <h3 className="funcionario-login-title">Login Funcionário</h3>
                <p className="text-muted mb-0">Digite seu código de acesso para continuar</p>
              </div>

              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Código de Acesso</Form.Label>
                  <Form.Control
                    type="text"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                    required
                    disabled={loading}
                    className="funcionario-code-input"
                    style={{ 
                      textAlign: 'center',
                      fontSize: '18px',
                      letterSpacing: '1px',
                      fontFamily: 'monospace'
                    }}
                  />
                  <Form.Text className="text-muted">
                    Digite o código fornecido pelo administrador
                  </Form.Text>
                </Form.Group>

                <Button 
                  type="submit" 
                  variant="primary" 
                  size="lg"
                  className="w-100 mb-3"
                  disabled={loading || !codigo.trim()}
                >
                  {loading ? 'Entrando...' : 'ENTRAR'}
                </Button>
              </Form>

              <div className="text-center">
                <Button 
                  variant="link" 
                  onClick={handleBack}
                  className="funcionario-back-link"
                >
                  <ArrowLeft size={16} className="me-1" />
                  Voltar ao menu principal
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FuncionarioLogin;
